module.exports = __webpack_public_path__ + "img/sphere08-graph.fba5bb82.png";